import { ReactNode } from 'react';
import styled from 'styled-components';
import { Popover } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import Background from './InstalSDKPopoverBackground.png';

const TargetContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const PopoverDropdown = styled(Popover.Dropdown)`
  display: flex;
  flex-direction: column;
  background-image: url(${Background});
  background-position: bottom right;
  background-repeat: no-repeat;
  background-color: #1e1f21;
  padding-bottom: 90px;

  color: #fff;
  font-size: 14px;

  em {
    font-weight: bold;
    font-style: normal;
  }

  p {
    margin: 10px 0x;
  }
`;

export default function InstallSDKPopver({ children }: { children?: ReactNode }) {
  const [opened, { close, open }] = useDisclosure(false);
  return (
    <Popover width={416} position="top-start" shadow="md" radius={'10px'} opened={opened}>
      <Popover.Target>
        <TargetContainer onMouseEnter={open} onMouseLeave={close}>
          {children}
        </TargetContainer>
      </Popover.Target>
      <PopoverDropdown style={{ zIndex: 1000 }}>
        <em>Using the Hud SDK</em>
        <p>
          Get function-level insights in your IDE and power AI agents with your production
          context.
        </p>
      </PopoverDropdown>
    </Popover>
  );
}
